import React, { createContext, useState, useContext, useEffect } from "react";
import translations from "./translations.json"; // Import the translations file

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Initialize language state with localStorage or default to "ge"
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "ka";
  });

  // Update localStorage whenever language changes
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  // Function to toggle language
  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "ka" ? "en" : "ka"));
  };

  // Function to retrieve translated text
  const t = (key) => {
    try {
      const keys = key.split(".");
      return keys.reduce((acc, curr) => acc[curr], translations[language]) || key;
    } catch {
      return key; // Fallback to key if translation not found
    }
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
